<template>
  <div class="row">
    <div class="feeds-index-container" :class="{'col-12 col-md-10 offset-md-1': isPodcaster(), 'col-12': !isPodcaster()}">
      <podcast-index v-if="isPodcaster()" />
      <tabs-portlet v-else title="Feeds" :data-tabs="tabs">
        <template #table>
          <feeds-table />
        </template>
        <template #cards>
          <feed-grid :feeds-per-chunk="8" large />
        </template>
      </tabs-portlet>
    </div>
  </div>
</template>

<script>
import TabsPortlet from 'VueComponents/TabsPortlet';
import FeedsTable from 'VuePartials/Feeds/FeedsTable';
import FeedGrid from 'VuePartials/Home/FeedGrid.vue';
import PodcastIndex from "./Podcaster/PodcastIndex";

export default {
  components: {
    TabsPortlet,
    FeedGrid,
    FeedsTable,
    PodcastIndex,
  },
  data() {
    return {
      tabs: [
        {
          name: `table`,
          display: `Table layout`,
          lazy: true,
          active: false,
        },
        {
          name: `cards`,
          display: `Cards layout`,
          lazy: true,
          active: false,
        },
      ],
    };
  },
  beforeMount() {
    const default_feed_view = window.cookies.get('default_feed_view');
    if (default_feed_view) {
      this.setDefaultTab(default_feed_view);
    } else {
      this.setDefaultTab('table');
    }
  },
  mounted() {
    window.EventBus.$on(`tab-requested`, (payload) => {
      this.$cookies.set(`default_feed_view`, payload);
    });
  },
  methods: {
    setDefaultTab(name) {
      const target_tab = _.find(this.tabs, tab => tab.name === name);
      if (target_tab) {
        target_tab.active = true;
      }
    },
  },
};
</script>
